<template>
  <div >
    <Header
        @onRefreshClick="onRefresh"
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        :rightIcons="true"
    >
    </Header>
    <div>
      <van-form
          style="width: 100%; max-width: 500px; margin-top: 30px"
          ref="form"
      >
        <van-cell-group class="user-form-item" inset>
          <van-field
              v-for="(item, index) in patientList" :key="index"
              is-link
              readonly
              :label="item.name"
              @click="toBinahData(item.patient_id)"
          >
          <template #input v-if="item.binahdata_date">
            <div class="binah-value" >
              <span>HR: {{ item.heartrate }}</span>
              <span>SpO2: {{ item.oxygensaturation }}</span>
              <span>BR: {{ item.breathingrate }}</span>
              <span>SDNN: {{ item.sdnn }}</span>
              <span>SL: {{ item.stresslevel }}</span>
              <span>BP: {{ item.bloodpressuresys }}/{{ item.bloodpressuredia }}</span>
              <span>HbA1c: {{ item.hemoglobina1c }}</span>
            </div>
          </template>
          <template #input v-else>
            <div class="binah-value" >
              <span>最新データがありません</span>
            </div>
          </template>
          </van-field>
        </van-cell-group>
      </van-form>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import 'vant/es/toast/style';

import { GetPatientList } from "@/services/patient";
import { GetPatientDetails } from "@/services/patient";

export default {
  data() {
    return {
      patientList:[],
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.initPatientList();
    this.initbinahInfo();
  },
  created() {
  },
  methods: {
    async initPatientList() {
      let ret = await GetPatientList();
      if(ret.data.code >=0 && ret.data.data){
        this.patientList = ret.data.data;
      }
    },
    initbinahInfo() {
      GetPatientDetails().then((res) => {
        this.userInfo = res.data.data.detail;
        this.isInfoBack = true;
      });
    },
    onClickLeft() {
      history.back();
    },
    toBinahData(patient_id) {
      this.$router.push({
        path: "/binahData",
        query: {
          patient_id: patient_id,
        },
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.binah-value {
    max-width: 300px;
  }

.binah-value span {
  display: block;
  font-size: 14px;
  color: #969799;
}
</style>
